import TemplatePreview from "components/templatePreview/TemplatePreview";
import React from "react";

const FooterSelector = ({ templates, selectedId, onSelect }) => {
  return (
    <div className="space-y-4">
      {templates.map((template) => (
        <label
          key={template._id}
          className="border rounded-lg p-4 flex gap-3 cursor-pointer"
        >
          <input
            type="radio"
            checked={selectedId === template._id}
            onChange={() => onSelect(template)}
          />

          <div>
            <div>
              <TemplatePreview
                html={template.body}
                isSms={false}
                key={"preview-email-" + (template?._id || "new")}
              />
            </div>
          </div>
        </label>
      ))}
    </div>
  );
};

export default FooterSelector;
